var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.271484,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#171717"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_1535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2715 23.8C26.0315 23.8 23.8615 24.15 21.8315 24.808V29.148C21.8315 29.694 21.5095 30.184 21.0475 30.408C19.6755 31.094 18.4295 31.976 17.3235 32.998C17.0715 33.25 16.7215 33.39 16.3435 33.39C15.9515 33.39 15.6015 33.236 15.3495 32.984L11.8775 29.512C11.7469 29.3847 11.6436 29.2322 11.5738 29.0637C11.504 28.8953 11.4692 28.7143 11.4715 28.532C11.4715 28.14 11.6255 27.79 11.8775 27.538C16.1475 23.492 21.9155 21 28.2715 21C34.6275 21 40.3955 23.492 44.6655 27.538C44.9175 27.79 45.0715 28.14 45.0715 28.532C45.0715 28.924 44.9175 29.274 44.6655 29.526L41.1935 32.998C40.9415 33.25 40.5915 33.404 40.1995 33.404C39.8215 33.404 39.4715 33.25 39.2195 33.012C38.1048 31.9732 36.8458 31.1008 35.4815 30.422C35.2459 30.3065 35.0475 30.1272 34.9089 29.9044C34.7702 29.6816 34.697 29.4244 34.6975 29.162V24.822C32.6815 24.15 30.5115 23.8 28.2715 23.8Z",
    fill: "#FFD966"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_1535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6,
    height: 33.6,
    fill: "white",
    transform: "translate(11.4714 11.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleIcon);
export default __webpack_public_path__ + "static/media/tele-Icon.080f06a8172b22df7aecac893e540e65.svg";
export { ForwardRef as ReactComponent };